/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import { TemplatePortal } from '@angular/cdk/portal';
import { Directive, OnDestroy, OnInit, TemplateRef, ViewContainerRef } from '@angular/core';

import { TabDirective } from './tab.directive';

@Directive({
  selector: '[ghTabOptions]',
})
export class TabOptionsDirective extends TemplatePortal<any> implements OnInit, OnDestroy {
  constructor(private tabDirective: TabDirective,
              templateRef: TemplateRef<any>,
              viewContainerRef: ViewContainerRef) {
    super(templateRef, viewContainerRef);
  }

  ngOnInit(): void {
    this.tabDirective.setOptionsPortal(this);
  }

  ngOnDestroy(): void {
    this.tabDirective.setOptionsPortal(void 0);
  }
}
